import React from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import withRoleCheck from "components/hocs/withRoleCheck";
import _GenerateUrlModal from "components/modals/GenerateUrlModal";
import CallModal from "components/modals/CallModal";
import { isContactEmailable } from "helpers/contacts";
import { SendEmailModal as _SendEmailModal } from "routes/campaign/components/Modals";

const SendEmailModal = withRoleCheck(_SendEmailModal, [
  ACL_RELATIONSHIPS.campaignActionEmail.create,
]);

const GenerateUrlModal = withRoleCheck(_GenerateUrlModal, [
  ACL_RELATIONSHIPS.emailUrl.read,
  ACL_RELATIONSHIPS.emailUrl.generateUrl,
]);

export function CampaignContactTableActions({
  campaignId,
  entityId,
  contact,
  isIncluded = false,
  isCallable = false,
}) {
  return (
    <>
      <SendEmailModal
        campaignId={campaignId}
        entityId={entityId}
        contactId={contact?.id}
        contactEmail={contact?.email}
        disabled={!isIncluded || !isContactEmailable(contact)}
        iconOnly
      />
      <CallModal
        contactId={contact?.id}
        campaignId={campaignId}
        disabled={!isCallable}
        iconOnly
      />
      <GenerateUrlModal
        campaignId={campaignId}
        contactId={contact?.id}
        iconOnly
        disabled={!isIncluded}
      />
    </>
  );
}
